import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectRights  {
    _originalTypeClassName = "zAppDevManager.BO.ProjectRights";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectRights.translate = translateService;
}
this.Id = null;
this.CanDeleteProject = false;
this.CanEditProject = false;
this.CanCommit = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
CanDeleteProject:any;
CanEditProject:any;
CanCommit:any;
User:any;
Application:any;
static setUser = ($this, value) => {
var oldValue = $this.User;
$this.User = value;
if (value != null) {
}
}
static setApplication = ($this, value) => {
var oldValue = $this.Application;
$this.Application = value;
if (value != null) {
if (oldValue != null) {
Domain.Application.removeProjectRights(oldValue, $this);
}
Domain.Application.addProjectRights(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}